import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class ExportAPI extends BaseAPI {
  // function getExportURL(cacheKey) {

  // }
}

export default new ExportAPI('v1/export', 'Export', getApiUrl(apis.ExportAPI))
